import './Empty.scss'
import {Text, Box} from 'common/components'

interface EmptyProps {
  icon: JSX.Element
  title: string
}

export default function Empty({icon, title}: EmptyProps) {
  return (
    <div className="Empty">
      <Box mb={6}>{icon}</Box>
      <Text size="3xl" weight="medium">
        No {title}
      </Text>
    </div>
  )
}
